const RTL_LOCALES = ['he', 'ar']

// Takes the resolver as an argument rather than importing it: index.js imports
// this module, so reaching back into it would close an import cycle.
export function applyDocumentLocale(lng, resolve = (v) => v) {
  const html = document.documentElement
  const resolved = resolve(lng)
  html.lang = resolved
  html.dir = RTL_LOCALES.includes(resolved) ? 'rtl' : 'ltr'
}
